import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@kambria/kambria-lego';
import config from 'configs';
import { unit } from '@kambria/kambria-util';
import { ethBalanceOf } from 'modules/kat.reducer';


class BalanceOf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      result: '',
      address: props.blockchain.account
    }
  }

  onAddress = (e) => {
    this.setState({ address: e.target.value });
  }

  onBalanceOf = () => {
    this.props.ethBalanceOf(this.state.address, this.state.to).then(re => {
      this.setState({ result: re });
    }).catch(er => {
      this.setState({ result: 0 });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.blockchain.account !== prevProps.blockchain.account) {
      this.setState({ address: this.props.blockchain.account });
    }
  }

  render() {
    return (
      <div className="container">
        <h2 className="title">Balance Of</h2>
        <table className="mx-auto w-100 position-relative" style={{ "top": "72px" }}>
          <tbody>
            <tr>
              <td width="90%" className="pt-4">Target Ethereum Address</td>
              <td width="10%" className="pt-4">&nbsp;</td>
            </tr>
            <tr>
              <td>
                <input type="text" className="form-control w-100" onChange={this.onAddress} value={this.state.address} />
              </td>
              <td>
                <Button type="primary" size="sm" customStyle={{ "height": "40px" }} onClick={this.onBalanceOf}>Query</Button>
              </td>
            </tr>
            <tr>
              <td className="result success pr-0" width="30%">Balance: {unit.wkat2KAT(this.state.result)} {config.eth.TOKEN.UNIT}</td>
            </tr>
          </tbody>
        </table>
        <h3 className="definition">What is "Balance Of"?</h3>
        <p className="description d-block w-100 text-left">The number of token that you have in your wallet.</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  blockchain: state.blockchain,
  kat: state.kat
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ethBalanceOf
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BalanceOf);